import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Label = styled.span`
  padding: 1px 4px;
  border: 1px solid transparent;
  border-radius: 5px;

  a {
    color: inherit;
  }
`;

interface AcessoProps {
  fixed?: boolean;
  active?: boolean;
  paid?: boolean;
  color?: any;
  favorite?: any;
  hover?: any;
  like?: any;
  remove?: any;
  bold?: any;
}

export const Acesso = styled.div<AcessoProps>`
  position: relative;
  font-size: 16px;
  display: flex;
  padding: 0px 5px;

  svg {
    width: 20px !important;

    color: ${props =>
      props.color
        ? props.color
        : props.theme.darkMode || props.bold
        ? props.theme.interface5
        : props.theme.interface4};
  }

  ${props =>
    props.fixed &&
    css`
      svg {
        color: ${props => props.theme.brand_primary_color};
      }
    `}

  ${props =>
    props.active &&
    css`
      &:hover {
        svg {
          color: ${props.favorite
            ? darken(0.1, props.theme.favorite)
            : darken(0.1, props.theme.brand_primary_color)};
        }
        ${Label} {
          border: 1px solid ${props.theme.brand_secondary_color};
          border-radius: 5px;

          svg {
            transition: color 0.2s ease-in-out;
            color: ${props.theme.brand_primary_color};
          }
        }

        ${props.hover &&
        css`
          ${AcessoHover} {
            display: block;
          }
        `}
      }
    `}

  ${props =>
    props.favorite &&
    css`
      svg {
        color: ${props.fixed && props.theme.favoriteNew};
      }
    `}

    ${props =>
    props.like &&
    css`
      svg {
        color: ${props.like === 1
          ? props.theme.successNew
          : props.like === 2
          ? props.theme.errorNew
          : null};
      }
    `}

  ${props =>
    props.paid &&
    css`
      svg {
        color: ${props.fixed ? props.theme.success : props.theme.errorNew};
      }
    `}

  ${props =>
    props.remove &&
    css`
      svg {
        color: ${props.fixed && props.theme.errorNew};
      }
    `}
`;

interface AcessosListProps {
  showAccess?: boolean;
  disable?: boolean;
}

export const AcessosList = styled.div<AcessosListProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props =>
    props.showAccess ? 'space-between' : 'flex-end'};
  width: 100%;
  height: 100%;

  ${props =>
    props.disable &&
    css`
      ${Acesso} {
        color: props.theme.interface3 !important;
      }
    `}
`;

export const Value = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    cursor: pointer;
    margin-left: 10px;
  }
  span {
    color: ${props => props.theme.interface3} !important;
  }
`;

export const AcessoHover = styled.div`
  cursor: default;
  line-height: 1.5;
  font-size: 10px;
  padding: 6px;
  position: absolute;
  z-index: 999;
  top: 24px;
  margin-left: -7px;
  display: none;
  border-radius: 5px;
  background: ${props =>
    props.theme.darkMode ? props.theme.interface4 : props.theme.interface7};
  color: ${props => props.theme.interface1};
  border: 1px solid
    ${props =>
      props.theme.darkMode ? props.theme.interface4 : props.theme.interface7};
  text-transform: uppercase;

  &::before {
    content: '';
    position: absolute;
    top: -8px;
    width: 8px;
    height: 8px;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    border-bottom: 8px solid
      ${props =>
        props.theme.darkMode ? props.theme.interface4 : props.theme.interface7};
  }
`;
